import { getI18n } from '@/plugins/i18n'
import { formatShortDate } from '@/lib/utils'

import { extraFieldTypeEnum } from '@/stores/portal.store'

export const formatExtraValue = (field, value) => {
  if (value === null || value === undefined || value === '') return null
  if (field.field_type === extraFieldTypeEnum.BOOLEAN) return getI18n().t(value ? 'common.yes' : 'common.no')
  if (field.field_type === extraFieldTypeEnum.DATE) return formatShortDate(value)
  return String(value)
}

export const extraValueEntries = (fields, values) => (fields ?? [])
  .map(field => ({ field, label: formatExtraValue(field, values?.[String(field.id)]) }))
  .filter(entry => entry.label !== null)

export const newExtraField = () => ({ name: '', field_type: extraFieldTypeEnum.TEXT, options: [] })
